export default {"src":"/_next/static/media/cmlT5.fc82334d.svg","height":1938,"width":1300,"blurWidth":0,"blurHeight":0};